import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './press-kit-link.module.css';

type Props = {
  readonly companyId: number;
  readonly companyName: string;
};

export function PressReleaseInformationPressKitLink({
  companyId,
  companyName,
}: Props) {
  return (
    <a
      href={`/main/html/searchrlp/company_id/${companyId}?tab=press_kit`}
      className={clsx(
        styles.link,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      {companyName}のプレスキットを見る
    </a>
  );
}
